(function() {
    'use strict';
    angular.module('app').controller('TransitWarrantyClaimsController', TransitWarrantyClaimsController)
    TransitWarrantyClaimsController.$inject = [
        'TransitWarrantyClaimsTableService'
    ];

    function TransitWarrantyClaimsController(
        TransitWarrantyClaimsTableService
    ) {
        const vm = this;

        init();
        function init() {
            vm.transitWarrantyClaimsTabledata = new TransitWarrantyClaimsTableService().tableData;
        }
    }
})();


// WEBPACK FOOTER //
// ./js/controllers/transit-warranty/TransitWarrantyClaimsController.js